import { fiboClick } from '@/sdk/fibo';
export default {
  methods:{
    fiboClick(name,content){
      fiboClick(name,content);
    }
  }
}